import Vue from 'vue'

import { axiosRequest } from '@/plugins/axios-common'
import { handleError } from '@/store/handle-error'

export const PESiblingsIncomeRowActions = {
  initPeSiblingsIncomeRow: ({ commit }, index) => {
    commit('setPeSiblingsIncomeRowLock', { index, lock: true })
  },
  peSiblingsIncomeRefreshAll: ({ state, dispatch, commit }) => {
    for (const sibling of state.partyEdit.party.siblings) {
      dispatch('peSiblingsCardRefresh', { section: sibling, index: sibling.id })
      commit('setPeSiblingsIncomeRowLock', { index: sibling.id, lock: true })
    }
  },
  peSiblingsIncomeRowUpdate: async ({ commit, getters }, { id, section, index }) => {
    const party = getters.peParty

    return axiosRequest.
      patch(`/party_characteristics/${id}`, {
        siblings: {
          party_id: party.id,
          monthly_income: section.monthly_income,
          income_verification: section.income_verification,
        },
        id,
      }).
      then(({ data }) => {
        const updatedParty = data.party

        commit('setPeSiblingsIncomeRowLock', { index, lock: true })
        commit('pePatchParty', {
          siblings: updatedParty.siblings || [],
        })
      }).
      catch(handleError)
  },
}

export const PESiblingsIncomeRowMutations = {
  setPeSiblingsIncomeRowLock: (state, { index, lock }) => {
    if (!state.partyEdit.partySections.SiblingsIncomeRow) {
      Vue.set(state.partyEdit.partySections, 'SiblingsIncomeRow', {})
    }
    Vue.set(state.partyEdit.partySections.SiblingsIncomeRow, index, lock)
  },
}

export const PESiblingsIncomeRowGetters = {
  peSiblingsIncomeRowLock: state => index => state.partyEdit.partySections.SiblingsIncomeRow[index],
}
